export const PHONE_MASK = {
    us: '(000) 000-0000',
    mx: '00 0000 0000',
    au: '(00) 0000 0000',
};

